import Game from "./components/Game";
import useWindowDimensions from "./hooks/hooks";
import classes from "./App.module.css";

const App = () => {
  const {height, width} = useWindowDimensions();

  console.log(height, width)
  return <>
    {height > width ? <div className={classes.alert}>Please rotate your phone!</div> : <Game />}
  </>;
}

export default App;
